import AbstractLocalStorageService from './localStorageHelper/abstractLocalStorage'
import { LocalStorage, UrlParams } from '@const/consts'
import { Nullable } from '@store/types'

class LocalStorageService extends AbstractLocalStorageService {
  public getRedirectUrl (): Nullable<string> {
    return this._localStorage.getItem(LocalStorage.REDIRECT_TO_URL)
  }

  public setRedirectUrl (): void {
    const paramsString = window.location.search
    const searchParams = new URLSearchParams(paramsString)
    const redirectTo = searchParams.get(UrlParams.REDIRECT_TO)

    if (redirectTo) this._localStorage.setItem(LocalStorage.REDIRECT_TO_URL, redirectTo)
    else this._localStorage.removeItem(LocalStorage.REDIRECT_TO_URL)
  }

  public setLanguage (language: string): void {
    this._localStorage.setItem(LocalStorage.LANGUAGE, language)
  }

  public getLanguage (): string | null {
    return this._localStorage.getItem(LocalStorage.LANGUAGE)
  }

  public setInstance (instance: string): void {
    this._localStorage.setItem(LocalStorage.INSTANCE, instance)
  }

  public getInstance (): string | null {
    return this._localStorage.getItem(LocalStorage.INSTANCE)
  }
}

export default new LocalStorageService()
